import { useState, useLayoutEffect } from "react";

const useDrawer = (children) => {

  const DRAWER_CONTENT_ID = "drawer-content";

  // This is only to know if to draw the bottom container border
  const [isContentOverflowing, setIsContentOverflowing] = useState(false);
  useLayoutEffect(() => {
    const content = document.getElementById(DRAWER_CONTENT_ID);
    setIsContentOverflowing(content?.scrollHeight > content?.clientHeight);
  }, [children]);

  return {
    DRAWER_CONTENT_ID,
    isContentOverflowing
  };
};

export default useDrawer;
